/**
 * 文件说明:
 *
 * global 环境变量配置
 *
 * ----------------------------------------
 * 创建用户: leo
 */

const config = require(`./${HUZAN_ENV}.js`).default

export default {
    apiHost: '',
    weWorkPluginHost: '',
    accessTokenKey: 'OEM_WORK_MANAGER_ACCESS_TOKEN_KEY',
    cosAuthResStorageKey: 'OEM_WORK_MANAGER_COS_RES_KEY',
    initHzHeaderHelp: '',
    ...config,
}
